const PlusCircle: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75ZM12.6251 7.62499C12.6251 7.27981 12.3453 6.99999 12.0001 6.99999C11.6549 6.99999 11.3751 7.27981 11.3751 7.62499V11.375H7.6251C7.27992 11.375 7.0001 11.6548 7.0001 12C7.0001 12.3452 7.27992 12.625 7.6251 12.625H11.3751V16.375C11.3751 16.7202 11.6549 17 12.0001 17C12.3453 17 12.6251 16.7202 12.6251 16.375V12.625H16.3751C16.7203 12.625 17.0001 12.3452 17.0001 12C17.0001 11.6548 16.7203 11.375 16.3751 11.375H12.6251V7.62499Z"
      fill="currentColor"
    />
  </svg>
);

export default PlusCircle;
